/* tslint:disable:ordered-imports */
import 'pepjs'
import * as React from 'react'
import * as ReactDOM from 'react-dom'

import App from './App'
import './config/yup'
import * as serviceWorker from './serviceWorker'
/* tslint:enable:ordered-imports */

ReactDOM.render(<App />, document.getElementById('root'))

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
